import {Variant} from '@/components/atom/MChip/types'
import {Status} from '@/types/offers'
import {formatDate} from '@/utils/date-helper'
import {refusedStatusChip} from '@/utils/offer-rejection'

type Translator = (key: string, params?: Record<string, unknown>) => string

interface ChipDescriptor {
  icon?: string
  text: string
  variant?: Variant
  tooltip?: string
  trailingIcon?: string
}

function hasBeenResponded(offer: any): boolean {
  return Boolean(offer.updatedAtStatusAccepted || offer.updatedAtStatusRefused)
}

function baseChip(offer: any, t: Translator): ChipDescriptor {
  const text = t(`offers.status.${offer.status}`)
  const variant = offer.expired ? Variant.Disabled : undefined

  if (offer.status === Status.Pending && hasBeenResponded(offer)) {
    return {
      icon: 'fa-pencil',
      text,
      variant: variant || Variant.Warning,
      tooltip: t('offers.tooltip.pending-updated'),
    }
  }

  if (offer.status === Status.Pending && !hasBeenResponded(offer)) {
    return {
      icon: 'fa-hourglass',
      text,
      variant: variant || Variant.Warning,
    }
  }

  if (offer.status === Status.Accepted && offer.updatedStatusFromEmail) {
    return {
      icon: 'fa-envelope',
      text,
      variant: variant || Variant.Info,
      tooltip: t('offers.tooltip.accepted-email'),
    }
  }

  if (offer.status === Status.Refused) {
    return refusedStatusChip(offer, text, t)
  }

  if (offer.status === Status.Completed) {
    return {
      text,
      variant: Variant.Success,
    }
  }

  return {
    text,
    variant: variant || Variant.Info,
  }
}

export function offerStatusChip(offer: any, t: Translator): ChipDescriptor {
  const chip = baseChip(offer, t)

  if (offer.status === Status.Accepted && offer.reconfirmedAt) {
    const reconfirmedTooltip = t('offers.tooltip.reconfirmed-on', {date: formatDate(offer.reconfirmedAt)})
    return {
      ...chip,
      trailingIcon: 'fa-check-double',
      tooltip: [chip.tooltip, reconfirmedTooltip].filter(Boolean).join(' - '),
    }
  }

  return chip
}
